/**
 * Google Analytics 工具模块
 * 解决 SPA 路由切换不打点 + 跨域支付回调丢失来源的问题
 */

const GA_ID = 'G-Z9HJWBT1SQ'

/**
 * 安全调用 gtag
 */
function gtag() {
  try {
    if (window.gtag) {
      window.gtag.apply(null, arguments)
    }
  } catch (_) {
    // 第三方统计异常不得影响业务流程
  }
}

/**
 * 发送 page_view 事件
 * 用于 SPA 路由切换时手动触发
 */
export function trackPageView(path, title) {
  gtag('config', GA_ID, {
    page_path: path,
    page_title: title || document.title
  })
}

/**
 * 从 sessionStorage 恢复 UTM 来源信息
 * 用于支付回调页面，防止跨域跳转后来源变成 (not set)
 */
export function restoreTrafficSource() {
  const source = sessionStorage.getItem('ga_utm_source')
  if (source) {
    gtag('set', {
      campaign_source: source,
      campaign_medium: sessionStorage.getItem('ga_utm_medium') || '(none)',
      campaign_name: sessionStorage.getItem('ga_utm_campaign') || '(none)'
    })
  }
}

/**
 * 发送自定义事件
 */
export function trackEvent(eventName, params = {}) {
  gtag('event', eventName, params)
}

/**
 * 安装路由守卫，自动追踪 SPA 页面切换
 */
export function setupRouterTracking(router) {
  router.afterEach((to) => {
    trackPageView(to.path, to.name || to.meta?.title)
  })
}
